import { render, staticRenderFns } from "./galleryDetails.vue?vue&type=template&id=7a635f3c&scoped=true&"
import script from "./galleryDetails.vue?vue&type=script&lang=js&"
export * from "./galleryDetails.vue?vue&type=script&lang=js&"
import style0 from "./galleryDetails.vue?vue&type=style&index=0&id=7a635f3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a635f3c",
  null
  
)

export default component.exports